export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#030303] border-t border-[#B49A6C]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 flex items-center justify-center">
        <p className="text-[9px] uppercase tracking-[0.35em] text-[#807C70]">
          © {year} Subconscious Lab
        </p>
      </div>
    </footer>
  );
}
